import { useState, useEffect } from "react";
import useMeteringPoints from "./useMeteringPoints";

function useRefPeriods() {
  const { getQuarantined, getRefPeriodChanged } = useMeteringPoints();  
  const [quarantined, setQuarantined] = useState([]);
  const [changed, setChanged] = useState([]); 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      getQuarantined(), 
      getRefPeriodChanged()
    ]).then(result => {
      setQuarantined(result[0])
      setChanged(result[1])
      setLoading(false);
    })
  }, [])

  return { loading, quarantined, changed };
}

export default useRefPeriods;